import React, {Component} from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

export default class MegaMenuItemThirdLevel extends Component {
  static propTypes = {
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
    obfuscate: PropTypes.bool,
    disableForLanguage: PropTypes.bool,
    class: PropTypes.string,
    classStyle: PropTypes.string,
    count: PropTypes.number,
  }

  static defaultProps = {
    title: '',
    url: '',
    hasChildren: false,
    isExpanded: false,
    isCollapsed: false,
    inActiveTrail: false,
    subtree: null,
    obfuscate: false,
    disableForLanguage: false,
    class: '',
    classStyle: '',
    count: null,
  }

  state = {
    thirdLevelIsOpen: false
  }

  renderLink = () => {
    const {
      title,
      url,
      subtree,
      obfuscate,
      obfuscateDataUrl,
      count,
      attributes,
    } = this.props

    const hasChildren = Object.keys(subtree).length > 0
    let classFromBO = ''
    let targetFromBO = ''

    if (typeof attributes === 'object') {
      classFromBO = attributes.class
      targetFromBO = attributes.target
    }

    if (obfuscate) {
      // obfuscated link
      return (
        <span className={cn('obfuscate', classFromBO)} data-link={obfuscateDataUrl} data-target={targetFromBO}>
            {title} {count && ` (${ count})`}
        </span>
      )
    } else {
      // default link
      return (
        <a href={url} className={cn(classFromBO)} data-target={targetFromBO}>
          {title} {count && ` (${ count})`}
        </a>
      )
    }
  }

  render() {
    const {
      classStyle,
    } = this.props

    return (
      <div
        role="presentation"
        className={cn('mobile-menu__item', classStyle)}
      >
        {this.renderLink()}
      </div>
    )
  }
}
